/**
 * SoundSettingsSection — Sound sub-screen body.
 * Web port of client-native SoundSettingsScreen.tsx: a single "Sound Effects"
 * toggle (isSoundEffectsEnabled). Copy matches iOS verbatim.
 */
import { FC } from "react";
import { SettingsToggle } from "../SettingsToggle";
import { useSettingsToggle } from "./useSettingsToggle";

const SoundSettingsSection: FC = () => {
  const { settings, isLoading, toggle } = useSettingsToggle();

  return (
    <SettingsToggle
      label="Sound Effects"
      isChecked={settings?.isSoundEffectsEnabled || false}
      onChange={() => toggle("isSoundEffectsEnabled")}
      isDisabled={isLoading}
      helpContent={
        <div>
          <p>
            <strong>Sound Effects</strong>
          </p>
          <p>Enable or disable the sounds that play between lessons.</p>
        </div>
      }
    />
  );
};

export default SoundSettingsSection;
